export const typeOfCpd = {
  ExternalCPD: {
    key: 'ExternalCPD',
    description: 'i.e. workshops, conferences and PD days'
  },
  FormalRelevantEducation: {
    key: 'FormalRelevantEducation',
    description: 'i.e. degree equivalent study (max 30hr per year)'
  },
  NonFormalEducation: {
    key: 'NonFormalEducation',
    description: 'i.e. association designation training (e.g. CFP)'
  },
  TechnicalAndProfessionalReading: {
    key: 'TechnicalAndProfessionalReading',
    description: '(max 4hr per year)'
  }
}


// WEBPACK FOOTER //
// ./src/constants/type-of-cpd.js